import React, { useEffect } from 'react';
import compose from 'lodash.flowright';
import PropTypes from 'prop-types';
import qs from 'query-string';
import { graphql } from 'react-apollo';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { accountLoginByOAuth as accountLoginByOAuthMutation } from '../../../../graphql/mutations/account';
import FullScreenLoader from '../../../../components/global/FullScreenLoader';
import getConfig from '../../../../util/config';
import { openAlert as openAlertAction } from '../../../../actions/modal-actions';
import { getErrorString } from '../../../../util/normalize-errors';
import ErrorView from '../../../../components/global/ErrorView';
import { isLocationPathname } from './helpers';
import { windowLocationAssign } from '../../../../util/navigation';

const propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  location: PropTypes.shape({
    search: PropTypes.string,
  }).isRequired,
  accountLoginByOAuth: PropTypes.func,
  openAlert: PropTypes.func,
  provider: PropTypes.string,
};

const OAuthLogin = ({
  history,
  location,
  accountLoginByOAuth,
  openAlert,
  provider,
}) => {
  const { code, state } = qs.parse(location?.search);

  const onLogin = async () => {
    try {
      await accountLoginByOAuth({ authCode: code, oauthProvider: provider });

      if (isLocationPathname(state)) {
        history.replace(state);
      } else {
        // use window.location to ensure
        // we reload the page.
        windowLocationAssign(`${getConfig().app.baseUrl}/app`);
      }
    } catch (err) {
      openAlert({
        type: 'error',
        title: 'Sorry, it appears we were not able to log you in.',
        message: getErrorString(err),
      });

      if (isLocationPathname(state)) {
        history.replace(state);
      } else {
        history.push('/shutterbug/signin');
      }
    }
  };

  useEffect(() => {
    if (code && provider) {
      onLogin();
    }
  }, [code]);

  if (!code || !provider) {
    return (
      <ErrorView
        location={{
          state: {
            error:
              'Sorry, something has gone wrong as the URL is missing a required parameter.',
          },
        }}
      />
    );
  }

  return <FullScreenLoader />;
};

OAuthLogin.propTypes = propTypes;

export { OAuthLogin as OAuthLoginComponent };

const withAccountLoginByOAuth = graphql(accountLoginByOAuthMutation, {
  props: ({ mutate }) => ({
    accountLoginByOAuth: ({ authCode, oauthProvider }) =>
      mutate({
        variables: {
          input: {
            oauth_provider: oauthProvider,
            auth_code: authCode,
            set_cookie: true,
          },
        },
      }),
  }),
});

const mapDispatchToProps = {
  openAlert: openAlertAction,
};

export default compose(
  withRouter,
  withAccountLoginByOAuth,
  connect(null, mapDispatchToProps),
)(OAuthLogin);
